/* Extra buckles & clasps — HEllO EDC

   A small configurator under Add to cart: Type, then Size / Colour / Finish,
   with the chosen piece previewed beside its price and a single Add button.

   Four dropdowns instead of a list. The spare catalogue is ~50 variants; laid
   out as rows it buried the page, and it is really one product with three
   axes, which is what a dropdown set is for.

   Option values that do not exist, or are out of stock, are disabled rather
   than hidden — a shopper should be able to see that Rose Gold exists in the
   Slim Dress but not the IWC. Changing a dropdown into an impossible
   combination snaps the others to the nearest one that can actually ship.

   Deliberately independent of wc-buckle.js: it reads the same config JSON and
   fetches the spare products itself, so a failure here cannot stop a strap
   being bought. If anything throws, the block simply never appears. */

(function () {
  'use strict';

  if (window.__wcExtrasInit) return;
  window.__wcExtrasInit = true;

  var cfg = null;
  var rows = [];                 /* every spare variant, across all families */
  var types = [];                /* family titles, in config order */
  var sel = { type: '', width: 0, colour: '', finish: '' };
  var built = false;
  var lastTaper = null;

  /* ---------- helpers (kept in step with wc-buckle.js) ---------- */

  function toInt(t) {
    var m = String(t == null ? '' : t).match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function money(cents) {
    var f = (cfg && cfg.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    if (f.indexOf('amount_no_decimals') > -1) v = Math.round(cents / 100).toString();
    var sym = (f.match(/^[^{]*/) || [''])[0].replace(/&[^;]+;/g, '').trim();
    return (sym || '$') + v;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function lugWidth() {
    var checked = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var n = (checked[i].name || '').toLowerCase();
      if (n.indexOf('lug') > -1 || n.indexOf('size') > -1 || n.indexOf('watch') > -1) {
        var v = toInt(checked[i].value);
        if (v) return v;
      }
    }
    return null;
  }

  /* The buckle that fits a 20mm lug is cut to the strap's taper, not the lug. */
  function taper() {
    var lug = lugWidth();
    if (lug == null || !cfg) return null;
    var t = cfg.taper[String(lug)];
    return t == null ? null : t;
  }

  /* ---------- data ---------- */

  function getProduct(handle) {
    return fetch(rootUrl() + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* The spare products carry no photography of their own — they are the same
     hardware sold loose. Imagery is borrowed from the parent buckle product,
     matched on finish + colour so a gold spare never shows a silver photo. */
  function shotsOf(p) {
    var byKey = {};
    ((p && p.variants) || []).forEach(function (v) {
      var src = v.featured_image && v.featured_image.src;
      if (src) byKey[(v.option1 || '') + '|' + (v.option2 || '')] = src;
    });

    var media = ((p && p.media) || [])
      .filter(function (m) { return m && m.media_type === 'image' && m.src; })
      .map(function (m) { return { src: m.src, alt: m.alt || '' }; });
    if (!media.length) {
      media = ((p && p.images) || []).map(function (s) { return { src: s, alt: '' }; });
    }

    return { byKey: byKey, media: media };
  }

  /* The photo for one finish + colour, read from the parent product's alt
     text ("<Title> — <Finish> <Colour> — <n>").

     The match is the exact "<finish> <colour>" phrase with a non-letter either
     side. A loose two-word search would match "rose gold" when looking for
     "gold". There is no cover-image fallback: this block used to fall back to
     the product cover, which meant every gold, rose gold and polished spare
     showed the brushed silver photograph. A colourway with no photography now
     shows no photograph, which the tile already renders as an empty state. */
  function shotFor(art, finish, colour) {
    var f = String(finish || '').trim();
    var c = String(colour || '').trim();
    if (!f && !c) return '';

    var rxEsc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var phrase = [f, c].filter(Boolean).map(rxEsc).join('\\s+');
    var re = new RegExp('(^|[^a-z])' + phrase + '([^a-z]|$)', 'i');

    var shots = (art && art.media) || [];
    for (var i = 0; i < shots.length; i++) {
      if (re.test(shots[i].alt || '')) return shots[i].src;
    }

    /* Nothing labelled anywhere — an unlabelled product can't be told apart,
       so its first photo is the best available answer. */
    var labelled = shots.some(function (s) { return !!(s.alt || '').trim(); });
    return (!labelled && shots[0]) ? shots[0].src : '';
  }

  function load() {
    var jobs = [];
    (cfg.families || []).forEach(function (fam) {
      if (!fam.spareHandle) return;
      types.push(fam.title);
      jobs.push(
        Promise.all([getProduct(fam.spareHandle), getProduct(fam.handle)])
          .then(function (both) {
            var p = both[0];
            if (!p) return;
            var art = shotsOf(both[1]);
            var own = shotsOf(p);

            /* A spare and the buckle fitted to a strap are two SKUs over one
               bin of hardware. If the fitted one is out of stock the spare
               cannot really ship either, whatever its own count says, so the
               parent's availability gates it. */
            var parentAvail = {};
            ((both[1] && both[1].variants) || []).forEach(function (v) {
              parentAvail[(v.option1 || '') + '|' + (v.option2 || '') + '|' +
                (toInt(v.option3) || 0)] = !!v.available;
            });

            (p.variants || []).forEach(function (v) {
              var key = (v.option1 || '') + '|' + (v.option2 || '');
              var full = key + '|' + (toInt(v.option3) || 0);
              var pa = parentAvail[full];
              rows.push({
                id: v.id,
                type: fam.title,
                finish: v.option1 || '',
                colour: v.option2 || '',
                width: toInt(v.option3) || 0,
                price: v.price,
                available: !!v.available && (pa === undefined ? true : pa),
                image: own.byKey[key] || art.byKey[key] ||
                  shotFor(art, v.option1, v.option2) ||
                  shotFor(own, v.option1, v.option2) || ''
              });
            });
          })
      );
    });
    return Promise.all(jobs).then(function () {
      types = types.filter(function (t) {
        return rows.some(function (r) { return r.type === t; });
      });
    });
  }

  /* ---------- the model ---------- */

  function pool() {
    return rows.filter(function (r) { return r.type === sel.type; });
  }

  function uniq(list) {
    var seen = {}, out = [];
    list.forEach(function (v) {
      var k = String(v);
      if (!seen[k]) { seen[k] = 1; out.push(v); }
    });
    return out;
  }

  function widths() {
    return uniq(pool().map(function (r) { return r.width; }))
      .sort(function (a, b) { return a - b; });
  }
  function colours() { return uniq(pool().map(function (r) { return r.colour; })); }
  function finishes() { return uniq(pool().map(function (r) { return r.finish; })); }

  function current() {
    return pool().filter(function (r) {
      return r.width === sel.width && r.colour === sel.colour && r.finish === sel.finish;
    })[0] || null;
  }

  /* Is there something we could actually sell if this one value were chosen? */
  function live(key, value) {
    /* A type is live if it has anything in stock at all — its own axes are
       judged inside it, not against the type we happen to be looking at. */
    if (key === 'type') {
      return rows.some(function (r) { return r.type === value && r.available; });
    }
    return pool().some(function (r) {
      if (!r.available) return false;
      return (key === 'width' ? r.width === value : r.width === sel.width) &&
        (key === 'colour' ? r.colour === value : r.colour === sel.colour) &&
        (key === 'finish' ? r.finish === value : r.finish === sel.finish);
    });
  }

  /* After any change, walk the axes in order and move each one only if it has
     to move, preferring a value that leaves something buyable. */
  function settle() {
    if (types.indexOf(sel.type) < 0) sel.type = types[0] || '';

    var ws = widths();
    if (ws.indexOf(sel.width) < 0) {
      var t = taper();
      sel.width = (t != null && ws.indexOf(t) > -1) ? t : ws[0];
    }

    var cs = colours();
    if (cs.indexOf(sel.colour) < 0 || !cs.length) {
      sel.colour = cs.filter(function (c) { return live('colour', c); })[0] || cs[0] || '';
    }

    var fs = finishes();
    if (fs.indexOf(sel.finish) < 0 || !fs.length) {
      sel.finish = fs.filter(function (f) { return live('finish', f); })[0] || fs[0] || '';
    }

    /* If that combination cannot ship, try the other finishes then colours for
       this width before giving up and showing it as unavailable. */
    if (!(current() || {}).available) {
      var fix = fs.filter(function (f) { return live('finish', f); })[0];
      if (fix) sel.finish = fix;
    }
    if (!(current() || {}).available) {
      var fixC = cs.filter(function (c) { return live('colour', c); })[0];
      if (fixC) {
        sel.colour = fixC;
        var fs2 = finishes().filter(function (f) { return live('finish', f); });
        if (fs2.length && fs2.indexOf(sel.finish) < 0) sel.finish = fs2[0];
      }
    }
  }

  /* ---------- markup ---------- */

  function build(host) {
    host.innerHTML =
      '<div class="wcx__head">' +
        '<h2 class="wcx__title">Add an extra buckle or clasp</h2>' +
        '<p class="wcx__note">Your strap already includes the one you chose above.</p>' +
      '</div>' +
      '<div class="wcx__box">' +
        '<div class="wcx__fields">' +
          '<label class="wcx__field wcx__field--wide">' +
            '<span class="wcx__label">Type</span>' +
            '<select class="wcx__select" data-wcx-sel="type"></select>' +
          '</label>' +
          '<label class="wcx__field">' +
            '<span class="wcx__label">Size</span>' +
            '<select class="wcx__select" data-wcx-sel="width"></select>' +
          '</label>' +
          '<label class="wcx__field">' +
            '<span class="wcx__label">Colour</span>' +
            '<select class="wcx__select" data-wcx-sel="colour"></select>' +
          '</label>' +
          '<label class="wcx__field">' +
            '<span class="wcx__label">Finish</span>' +
            '<select class="wcx__select" data-wcx-sel="finish"></select>' +
          '</label>' +
        '</div>' +
        '<div class="wcx__pick">' +
          '<button type="button" class="wcx__shot" data-wcx-shot ' +
            'aria-label="View this buckle larger"></button>' +
          '<span class="wcx__price" data-wcx-price></span>' +
          '<button type="button" class="wcx__add" data-wcx-add>Add</button>' +
        '</div>' +
      '</div>' +
      '<p class="wcx__err" data-wcx-err hidden></p>';
  }

  function fillSelect(el, list, value, key, labeller) {
    var sig = list.map(function (v) {
      return v + (live(key, v) ? '' : '!');
    }).join('~');

    if (el.getAttribute('data-wcx-sig') !== sig) {
      el.setAttribute('data-wcx-sig', sig);
      el.innerHTML = list.map(function (v) {
        return '<option value="' + esc(v) + '"' + (live(key, v) ? '' : ' disabled') + '>' +
          esc(labeller ? labeller(v) : v) + (live(key, v) ? '' : ' — unavailable') +
          '</option>';
      }).join('');
    }
    el.value = String(value);
  }

  function paint() {
    var host = document.querySelector('[data-wcx]');
    if (!host || !rows.length || !types.length) return;

    if (!built) { build(host); built = true; }

    /* A new lug width means a new size fits; move the size with it rather than
       leaving the shopper on the one that suited the last selection. */
    var t = taper();
    if (t !== lastTaper) {
      lastTaper = t;
      if (t != null && widths().indexOf(t) > -1) sel.width = t;
    }

    settle();

    fillSelect(host.querySelector('[data-wcx-sel="type"]'), types, sel.type, 'type');
    fillSelect(host.querySelector('[data-wcx-sel="width"]'), widths(), sel.width, 'width',
      function (w) { return w + 'mm'; });
    fillSelect(host.querySelector('[data-wcx-sel="colour"]'), colours(), sel.colour, 'colour');
    fillSelect(host.querySelector('[data-wcx-sel="finish"]'), finishes(), sel.finish, 'finish');

    /* Finish is not a choice when a type only has one. */
    var fField = host.querySelector('[data-wcx-sel="finish"]').closest('.wcx__field');
    if (fField) fField.hidden = finishes().length < 2;

    var v = current();
    var shot = host.querySelector('[data-wcx-shot]');
    var src = v && v.image ? thumb(v.image, 160) : '';
    if (shot.getAttribute('data-src') !== src) {
      shot.setAttribute('data-src', src);
      shot.innerHTML = src
        ? '<img src="' + esc(src) + '" alt="" width="80" height="80" ' +
          'loading="lazy" decoding="async">'
        : '';
      shot.classList.toggle('wcx__shot--none', !src);
    }

    var price = host.querySelector('[data-wcx-price]');
    var add = host.querySelector('[data-wcx-add]');
    if (v && v.available) {
      price.textContent = money(v.price);
      price.classList.remove('wcx__price--out');
      add.disabled = false;
      add.setAttribute('data-wcx-add', v.id);
    } else {
      price.textContent = 'Out of stock';
      price.classList.add('wcx__price--out');
      add.disabled = true;
      add.setAttribute('data-wcx-add', '');
    }

    host.hidden = false;
  }

  /* ---------- cart ---------- */

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function jsonPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  /* This theme marks an empty cart with an `is-empty` class on <cart-drawer>
     and <cart-drawer-items>, neither of which Dawn's own renderContents()
     clears. Adding the first thing to an empty cart therefore left the count
     at 1 above a drawer the CSS was still hiding. wc-cart.js already solved
     this for the strap; the same sync has to happen here. */
  function syncEmptyState(res) {
    var empty = !!(res && res.item_count === 0);
    var cd = document.querySelector('cart-drawer');
    if (cd) cd.classList.toggle('is-empty', empty);
    document.querySelectorAll('cart-drawer-items').forEach(function (el) {
      el.classList.toggle('is-empty', empty);
    });
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) inner.classList.toggle('is-empty', empty);
  }

  function sectionHasItems(res) {
    var html = res && res.sections && res.sections['cart-drawer'];
    if (!html) return false;
    try {
      return !!new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-item');
    } catch (e) {
      return false;
    }
  }

  /* Ask for a fresh drawer render, retrying briefly if Shopify hands back a
     sections snapshot that hasn't caught up with the write. */
  function freshSections(attempt) {
    attempt = attempt || 0;
    return jsonPost(rootUrl() + 'cart/update.js', {
      updates: {},
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    }).then(function (res) {
      if ((res && res.item_count === 0) || sectionHasItems(res) || attempt >= 2) return res;
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(freshSections(attempt + 1)); }, 180);
      });
    });
  }

  function addToCart(id, btn) {
    btn.disabled = true;
    btn.classList.add('is-busy');

    jsonPost(rootUrl() + 'cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function (res) {
        if (res && res.status) {
          throw new Error(res.description || res.message || 'Could not add');
        }
        return freshSections();
      })
      .then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        var bubble = document.getElementById('cart-icon-bubble');

        /* Clear the empty flag before painting, so the drawer isn't rendered
           while its own CSS is still hiding the contents. */
        syncEmptyState(res);

        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.renderContents(res);
          setTimeout(function () { syncEmptyState(res); }, 0);
        } else if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var inner = sectionInner(res.sections['cart-icon-bubble'], '#cart-icon-bubble');
          if (inner != null) bubble.innerHTML = inner;
        }

        btn.textContent = 'Added';
        btn.classList.add('is-done');
        setTimeout(function () {
          btn.textContent = 'Add';
          btn.classList.remove('is-done');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function (e) {
        var err = document.querySelector('[data-wcx-err]');
        if (err) {
          err.textContent = e && e.message ? e.message : 'Could not add that just now.';
          err.hidden = false;
        }
        btn.disabled = false;
      })
      .then(function () { btn.classList.remove('is-busy'); });
  }

  /* ---------- placement ---------- */

  /* The mount is emitted with the buckle config, which Liquid renders with the
     buy-buttons block. Moving it is cheaper and far less risky than editing
     the shared snippet on a live theme.

     Which button to sit under needs care. The real form lives in
     .button--cart--wrapper, but on this template the description block is
     ordered ahead of it and carries .dummy-buttons-wrapper — a decoy ADD TO
     CART that forwards its click to the real submit. That decoy is the button
     a shopper actually sees and presses, so it is the anchor; the real wrapper
     is the fallback for any template without it.

     The "Buckle: … included" note travels with the block, so the confirmation
     stays beside the thing it confirms rather than stranded down the page. */
  function anchor() {
    return document.querySelector('.dummy-buttons-wrapper') ||
      document.querySelector('.button--cart--wrapper');
  }

  function place() {
    var host = document.querySelector('[data-wcx]');
    if (!host) return false;

    var a = anchor();
    if (!a || !a.parentNode) return false;

    var after = a;

    var note = document.querySelector('[data-wc-total]');
    if (note) {
      if (note.previousElementSibling !== a) {
        a.parentNode.insertBefore(note, a.nextSibling);
      }
      after = note;
    }

    if (host.previousElementSibling !== after) {
      after.parentNode.insertBefore(host, after.nextSibling);
    }
    return true;
  }

  function boot() {
    var el = document.querySelector('[data-wc-buckle-data]');
    if (!el) return;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    if (!cfg || !cfg.families || !cfg.families.length) return;

    if (!place()) return;

    document.addEventListener('change', function (e) {
      var s = e.target.closest('[data-wcx-sel]');
      if (!s) return;
      var key = s.getAttribute('data-wcx-sel');
      sel[key] = key === 'width' ? parseInt(s.value, 10) : s.value;
      var err = document.querySelector('[data-wcx-err]');
      if (err) err.hidden = true;
      paint();
    });

    document.addEventListener('click', function (e) {
      var shot = e.target.closest('[data-wcx-shot]');
      if (shot) {
        e.preventDefault();
        if (typeof window.WCBuckleZoom === 'function') {
          window.WCBuckleZoom(sel.type, sel.colour, sel.finish);
        }
        return;
      }

      var add = e.target.closest('[data-wcx-add]');
      if (!add) return;
      e.preventDefault();
      e.stopPropagation();
      var id = parseInt(add.getAttribute('data-wcx-add'), 10);
      if (id) addToCart(id, add);
    });

    load().then(function () {
      /* Open on whatever the shopper picked in the drawer, at the size that
         fits — the likeliest spare is a second of what they just chose. */
      var chosen = window.WCBuckle && window.WCBuckle.componentTitle;
      sel.type = types.indexOf(chosen) > -1 ? chosen : types[0];
      var t = taper();
      if (t != null) sel.width = t;
      paint();
    });

    /* Lug width changes which size fits. */
    document.addEventListener('wc-buckle:change', function () {
      if (built) { place(); paint(); }
    });

    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (!built || pending) return;
        pending = setTimeout(function () { pending = null; place(); paint(); }, 120);
      }).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
